export default {
  slug: "aboutu-wins-again-3rd-year-running-at-the-winter-business-league",
  title: "AboutU Wins Again: 3rd Year Running at the Winter Business League",
  date: "2026-08-25",
  author: "About U",
  cover: "/images/blog/padel-league-cover.webp",
  coverAlt: "The AboutU padel team with their trophies at Garden Route Padel",
  body: `
We're thrilled to share some exciting news, AboutU has claimed victory at the Garden Route Padel Winter Business League for the third year in a row!

![The AboutU padel team at Garden Route Padel](/images/blog/padel-league-team.webp)

It's become a bit of a tradition now, and one we're incredibly proud of. Competing against other local businesses on the padel court is always a highlight of our year, and taking the win three years running says a lot about the team spirit that carries through everything we do.

A huge thank you to everyone at Garden Route Padel for hosting another great league, and congratulations to our team for keeping the trophy at AboutU.

Here's to defending the title again next year!

The aboutU family
`,
};
